export const EMPTY_OBJECT = Object.freeze({})
export const NOOP = () => undefined
export const MAX_MOBILE_WIDTH = 960
// The DS (Panda) desktop layout begins at the `lg` breakpoint (min-width: 1200px).
export const DS_DESKTOP_MIN_WIDTH = 1200
// For APIs that take a media query, not a Panda condition (Embla `breakpoints`, `matchMedia`).
// @i18n-ignore
export const DS_LG_MEDIA_QUERY = `(min-width: ${DS_DESKTOP_MIN_WIDTH}px)`
export const MAX_DESKTOP_WIDTH = 1600
// @i18n-ignore
export const QUINCE = 'Quince'
export const EN_US = 'en_US'
// @i18n-ignore
export const CONTENT_QUERY_PARAM = 'content-version'
// @i18n-ignore
export const NO_COLOR_OPTION_NAME = 'No Color'
